import Pricing from "../../fragments/pricing";

function CustomerPricing({ customerId }) {
  return (<Pricing customerId={customerId} />)
}

export default CustomerPricing;